export function initAccordionTeasers() {
  const toggles = document.querySelectorAll('[data-accordion-toggle]');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const card = toggle.closest('[data-accordion]');
      if (!card) return;

      const isOpen = card.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
}
